import ItemNumber from '~/components/cms/custom/ItemNumber.vue';
import ItemImageText from '@/components/cms/custom/ItemImageText/ItemImageText.vue';
import RichText from '~/components/ui/RichText.vue';
export default defineComponent({
  name: 'BlockEnumerationStandard',
  components: {
    ItemNumber: ItemNumber,
    ItemImageText: ItemImageText,
    RichText: RichText
  },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    title: String,
    classes: {
      type: Object,
      default: function _default() {}
    },
    note: {
      type: Object,
      default: null
    }
  }
});